import { ReactNode } from "react";

import { useAuth } from "@contexts/auth";

// Unmounts protected controls when permissions are revoked, including open forms.
export const PermissionGate = ({ permission, children }: { permission: string | string[]; children: ReactNode }) => {
  const { can } = useAuth();
  return (Array.isArray(permission) ? permission.some(can) : can(permission)) ? <>{children}</> : null;
};
